export const SURVEY_LOGIN_URL_KEY = "survey.loginUrl";
export const DEFAULT_SURVEY_LOGIN_URL = "https://auth.surveys.feradel.com";
export const DEFAULT_SURVEY_HOME_URL = "https://surveys.feradel.com";

const SAFE_RETURN_PATHS = ["/dashboard", "/public/survey/", "/s/"];

export const rememberSurveyLoginUrl = (loginUrl) => {
  if (!loginUrl) {
    sessionStorage.removeItem(SURVEY_LOGIN_URL_KEY);
    return;
  }

  sessionStorage.setItem(SURVEY_LOGIN_URL_KEY, loginUrl);
};

export const rememberedSurveyLoginUrl = () =>
  sessionStorage.getItem(SURVEY_LOGIN_URL_KEY);

export const surveyLoginUrl = () =>
  window.FERADEL_SURVEY_AUTH_URL
  || process.env.REACT_APP_SURVEY_AUTH_URL
  || DEFAULT_SURVEY_LOGIN_URL;

export const isSafeSurveyReturnUrl = (value) => {
  try {
    const target = new URL(value, window.location.origin);
    const trustedOrigins = new Set([
      window.location.origin,
      new URL(DEFAULT_SURVEY_HOME_URL).origin,
    ]);
    return trustedOrigins.has(target.origin)
      && SAFE_RETURN_PATHS.some(path =>
        target.pathname === path || target.pathname.startsWith(path)
      );
  } catch {
    return false;
  }
};

export const buildLoginRedirectUrl = (loginUrl, nextUrl) => {
  if (!loginUrl || !nextUrl || !isSafeSurveyReturnUrl(nextUrl)) return null;

  try {
    const target = new URL(loginUrl, window.location.origin);
    if (!["http:", "https:"].includes(target.protocol)) return null;

    target.searchParams.set("next", nextUrl);
    return target.toString();
  } catch {
    return null;
  }
};

export const expiredSessionRedirectUrl = (
  error,
  nextUrl = window.location.href
) => {
  const status = Number(error?.response?.status || error?.status);
  if (status !== 401) return null;

  return buildLoginRedirectUrl(rememberedSurveyLoginUrl() || surveyLoginUrl(), nextUrl);
};

export const redirectExpiredSession = (
  error,
  {
    nextUrl = window.location.href,
    tokenStorage = localStorage,
    navigate = (url) => window.location.replace(url),
  } = {}
) => {
  const redirectUrl = expiredSessionRedirectUrl(error, nextUrl);
  if (!redirectUrl) return false;

  tokenStorage.removeItem("token");
  navigate(redirectUrl);
  return true;
};
